<script>
  export default {
    name: 'ConductInspectionItemConditional',
    components: {
      ConductInspectionItem: () => import('@/_legacy/components/ConductInspection/ConductInspectionItem.vue'),
    },
    props: {
      entities: {
        type: Object,
        required: true,
      },
      item: {
        type: Object,
        required: true,
      },
      previewMode: {
        type: [Boolean, String],
        default: false,
      },
    },
  };
</script>

<template>
  <transition-group name="fade" mode="out-in" appear>
    <div v-if="item.allConditionsMet" :key="item.uuid">
      <ConductInspectionItem
        v-for="item in entities.items[item.uuid].items"
        :key="item"
        :item="entities.items[item]"
        :entities="entities"
        :preview-mode="previewMode"
        v-on="$listeners"
      />
    </div>
  </transition-group>
</template>
